import { motion } from "framer-motion";
import { MenuItem } from "./MenuItem";

const variants = {
  open: {
    
    pointerEvents: "auto",
    cursor: "auto",
    transition: { staggerChildren: 0.07, delayChildren: 0.2 }
  },
  closed: {
   
    pointerEvents: "none",
    cursor: "default",
    transition: { staggerChildren: 0.05, staggerDirection: -1 }
  },
};

export const Navigation = () => (
  <motion.ul
    variants={variants}
    initial={false} 
  >
    {itemIds.map((i) => (
      <MenuItem i={i} key={i} />
    ))}
  </motion.ul>
);

const itemIds = [0, 1, 2, 3, 4];
